import { SessionRequest } from '../dto/session-request';

/**
 * CreditPlan class holds credit plan information returned from the backend
 *
 * @note Process fee and payment factor are not included in the credit plan
 * to avoid performing math in the frontend
 */
export class CreditPlan {
  private _active: boolean;
  private _title: string;
  private _minRequiredSpend: number;
  private _aprPercent: string;
  private _termLength: string;
  private _disclosure: string;
  private _processFee: number;

  constructor(
    active: boolean,
    title: string,
    minRequiredSpend: number,
    aprPercent: string,
    termLength: string,
    disclosure: string,
    processFee: number,
  ) {
    this._active = active;
    this._title = title;
    this._minRequiredSpend = minRequiredSpend;
    this._aprPercent = aprPercent;
    this._termLength = termLength;
    this._disclosure = disclosure;
    this._processFee = processFee;
  }

  // Getters
  get active(): boolean {
    return this._active;
  }

  get title(): string {
    return this._title;
  }

  get minRequiredSpend(): number {
    return this._minRequiredSpend;
  }

  get aprPercent(): string {
    return this._aprPercent;
  }

  get termLength(): string {
    return this._termLength;
  }

  get disclosure(): string {
    return this._disclosure;
  }

  get processFee(): number {
    return this._processFee;
  }

  // Setters
  set active(value: boolean) {
    this._active = value;
  }

  set title(value: string) {
    this._title = value;
  }

  set minRequiredSpend(value: number) {
    this._minRequiredSpend = value;
  }

  set aprPercent(value: string) {
    this._aprPercent = value;
  }

  set termLength(value: string) {
    this._termLength = value;
  }

  set disclosure(value: string) {
    this._disclosure = value;
  }

  set processFee(value: number) {
    this._processFee = this.processFee;
  }
}

/**
 * Helper class to map SessionRequest DTO to CreditPlan model
 */
export class CreditPlanMapper {
  /**
   * Maps a SessionRequest DTO to a CreditPlan model instance
   * @param request The SessionRequest DTO from the backend
   * @returns A new CreditPlan instance
   */
  static toCreditPlan(request: SessionRequest): CreditPlan | null {
    if (request.onlyShowApplication) return null;

    return new CreditPlan(
      request.creditPlan.active,
      request.creditPlan.planName,
      request.creditPlan.minRequiredSpend,
      '' + request.creditPlan.apr,
      '' + request.creditPlan.termLength,
      request.creditPlan.disclosure,
      request.processingFee,
    );
  }
}
